// src/app/admin/pages/statistics/statistics.component.ts
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FilterStatistics, LoadProjectUserReport } from '@dwo/actions';
import {
  getFilteredProjectUserReport,
  getUserReportFilter,
  getProjectUserReportLoading,
} from '@app/core/store/selectors/project.selector';
import { ProjectUserReportDto } from '@app/generated/model';

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.scss'],
  standalone: false,
})
export class StatisticsComponent implements OnInit, OnDestroy {
  filter = '';
  readonly displayColumns: string[] = [
    'projectId',
    'projectName',
    'activeUserCount',
    'authorizedUserCount',
    'activeUsersByVersion',
    'authorizedUsersByVersion',
  ];
  dataSource: MatTableDataSource<ProjectUserReportDto> = new MatTableDataSource();
  loading = false;
  private readonly destroy$ = new Subject<void>();

  @ViewChild(MatSort, { static: false }) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  constructor(private readonly store: Store) {}

  ngOnInit(): void {
    this.store.dispatch(new LoadProjectUserReport());

    this.store
      .select(getFilteredProjectUserReport)
      .pipe(takeUntil(this.destroy$))
      .subscribe((report) => (this.dataSource.data = report));

    this.store
      .select(getUserReportFilter)
      .pipe(takeUntil(this.destroy$))
      .subscribe((filter) => (this.filter = filter));

    this.store
      .select(getProjectUserReportLoading)
      .pipe(takeUntil(this.destroy$))
      .subscribe((loading) => (this.loading = loading));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onRefresh(): void {
    this.store.dispatch(new LoadProjectUserReport());
  }

  onFilterChange(filter: string): void {
    this.store.dispatch(new FilterStatistics(filter));
  }

  versionEntries(map?: { [key: string]: number }): { version: string; count: number }[] {
    if (!map) return [];
    return Object.entries(map)
      .map(([version, count]) => ({ version, count }))
      .sort((a, b) => b.version.localeCompare(a.version, undefined, { numeric: true }));
  }
}
